import { createAppKit } from '@reown/appkit/react'
import { EthersAdapter } from '@reown/appkit-adapter-ethers'
import { mainnet } from '@reown/appkit/networks'
import { APP_METADATA, WC_PROJECT_ID } from './constants.js'

/**
 * AppKit (Side B): SafeWard is a *dApp* that connects to Rabby (where
 * Ainura's key lives). When SafeWard needs Ainura's owner sig on a
 * Module Safe tx, it uses the AppKit-managed connection to send an
 * `eth_signTypedData_v4` request to Rabby.
 */

let initialized = false

export function initAppKit(): void {
  if (initialized) return
  createAppKit({
    adapters: [new EthersAdapter()],
    networks: [mainnet],
    projectId: WC_PROJECT_ID,
    metadata: APP_METADATA,
    features: {
      analytics: false,
      email: false,
      socials: false,
    },
    themeMode: 'dark',
  })
  initialized = true
}
